export type RangeStrategy =
  | 'auto'
  | 'bump'
  | 'future'
  | 'pin'
  | 'replace'
  | 'update-lockfile'
  | 'in-range-only'
  | 'widen';
